<template>
	<div class="my-schedule-today">
		<widget title="My Schedule Today" icon="fa-calendar" :max-height="maxHeight" :no-padding="true">
			<div v-if="widgetSpinner" class="schedule-spinner">
				<spinner :inline="true"></spinner>
			</div>
			<ul v-else-if="events.length > 0" class="list-group list-group-flush">
				<list-job-tile
					v-for="event in events"
					:key="event.id"
					:icon="eventIcon(event)"
					:title="eventTitle(event)"
					:right-text="formatDateTimeToLocal(event.start_time, 'time')"
					:meta="eventMeta(event)"
					:customer-name="eventCustomerName(event)"
					:address="eventAddress(event)"
					:to="eventDashboardLink(event) || undefined">
				</list-job-tile>
			</ul>
			<p v-else class="empty-schedule-msg">You have no events for today</p>
		</widget>
	</div>
</template>
<script type="text/javascript">
import Widget from "@/components/Widget"
import ListJobTile from "@/components/ListJobTile"
import Spinner from "@/components/Spinner"

export default {
	name: "MyScheduleToday",
	components: {
		Widget,
		ListJobTile,
		Spinner
	},
	props: ["maxHeight"],
	data() {
		return {
			events: [],
			widgetSpinner: true
		}
	},
	methods: {
		eventIcon(event) {
			if (event.is_vacation == 1)
				return "fa-umbrella-beach"
			if (event.is_sickday == 1)
				return "fa-first-aid"
			if (event.service_id > 0 && event.Service)
				return "fa-wrench"
			if (event.job_id > 0 && event.Job)
				return "fa-cube"
			return "fa-calendar-alt"
		},
		eventTitle(event) {
			if (event.title)
				return event.title
			if (event.service_id > 0 && event.Service)
				return event.Service.job_name
			if (event.job_id > 0 && event.Job)
				return event.Job.job_name
			if (event.is_vacation == 1)
				return "Vacation"
			if (event.is_sickday == 1)
				return "Medical Leave"
			return "Generic Event"
		},
		eventMeta(event) {
			if (event.service_id > 0 && event.Service)
				return "Service #" + event.Service.job_num
			if (event.job_id > 0 && event.Job)
				return "Project #" + event.Job.job_num
			return ""
		},
		eventDashboardLink(event) {
			if (event.service_id > 0 && event.Service)
				return "/service/" + event.Service.slug + "/dashboard"
			if (event.job_id > 0 && event.Job)
				return "/project/" + event.Job.slug + "/dashboard"
			return false
		},
		eventCustomerName(event) {
			if (event.service_id > 0 && event.Service && event.Service.Customer)
				return event.Service.Customer.name
			if (event.job_id > 0 && event.Job && event.Job.Customer)
				return event.Job.Customer.name
			return ""
		},
		eventAddress(event) {
			let entity = null
			if (event.service_id > 0 && event.Service)
				entity = event.Service
			else if (event.job_id > 0 && event.Job)
				entity = event.Job

			if (!entity || !entity.address)
				return ""

			if (entity.city)
				return entity.address + ", " + entity.city

			return entity.address
		},
		fetchEvents() {
			let vm = this
			let dayStart = this.moment().startOf('day').format("YYYY-MM-DD HH:mm:ss")
			let dayEnd = this.moment().endOf('day').format("YYYY-MM-DD HH:mm:ss")

			let params = {
				filters: [
					["user_id", this.$store.userDetails.id],
					["start_time >=", dayStart],
					["start_time <=", dayEnd],
					['is_published', 1]
				],
				orders: [
					["start_time", "ASC"]
				],
				include: [
					{
						model: "Job",
						fields: ["id", "slug", "job_num", "job_name", "address", "city"],
						include: [
							{model: "Contact", fields: ["name"]}
						]
					},
					{
						model: "Service",
						fields: ["id", "slug", "job_num", "job_name", "address", "city"],
						include: [
							{model: "Contact", fields: ["name"]}
						]
					}
				]
			}

			this.widgetSpinner = true

			this.getJSON("ScheduleEvent/get", params).then(response => {
				vm.widgetSpinner = false

				if (response.success)
					vm.events = response.data
			})
		}
	},
	mounted() {
		this.fetchEvents()
	}
}
</script>

<style scoped>
.my-schedule-today >>> .widget-card {
	overflow: hidden;
}

.schedule-spinner,
.empty-schedule-msg {
	padding: 1rem;
	margin-bottom: 0;
}
</style>
